import React, { useState } from 'react';
import { strapiService } from '../../../utils/api';
import AlertService from '../../../utils/alertService';
import { IconButton, Sym } from '../../../components/app2';

/**
 * Un recibo dentro de la lista: quién, de qué periodo, cuánto y sus descargas.
 * Se usa tanto dentro de un periodo abierto como en los resultados de búsqueda
 * (ahí sí se muestra el periodo, porque mezclan varios).
 */

const money = (n) => new Intl.NumberFormat('es-MX', {
  style: 'currency', currency: 'MXN', maximumFractionDigits: 2,
}).format(Number(n) || 0);

const fecha = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
};

const nombreDe = (e) => [e?.first_name, e?.last_name].filter(Boolean).join(' ') || 'Sin empleado';

const descargarBlob = (blob, nombre) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

const ReceiptRow = ({ receipt, mostrarPeriodo = false }) => {
  const [bajando, setBajando] = useState(null);
  const empleado = receipt?.employee;

  const bajar = async (tipo) => {
    try {
      setBajando(tipo);
      const blob = tipo === 'pdf'
        ? await strapiService.payroll.downloadPDF(receipt.id)
        : await strapiService.payroll.downloadXML(receipt.id);
      const base = `recibo-${receipt?.folio || receipt?.id}-${nombreDe(empleado).replace(/\s+/g, '-')}`;
      descargarBlob(blob, `${base}.${tipo}`);
    } catch (e) {
      console.error(`Error descargando ${tipo}:`, e);
      AlertService.error('No se pudo descargar', `El ${tipo.toUpperCase()} de este recibo no está disponible.`);
    } finally {
      setBajando(null);
    }
  };

  return (
    <div className="a2-trow" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <span
        className="a2-avatar a2-hide-sm"
        style={{
          width: 34, height: 34, borderRadius: 10, flexShrink: 0, fontSize: '.78rem',
          background: 'var(--surface-2)', border: '1px solid var(--line-2)', color: 'var(--muted)',
        }}
        aria-hidden
      >
        <Sym name="description" size={18} />
      </span>

      <span style={{ flex: 1, minWidth: 0 }}>
        <span className="a2-tcell-strong a2-truncate" style={{ display: 'block' }}>
          {nombreDe(empleado)}
        </span>
        <span className="a2-tcell-muted" style={{ display: 'block' }}>
          <span className="a2-mono">{empleado?.rfc || 'Sin RFC'}</span>
          {receipt?.folio ? ` · folio ${receipt.folio}` : ''}
          {mostrarPeriodo ? ` · ${fecha(receipt?.pay_period_start)} → ${fecha(receipt?.pay_period_end)}` : ''}
        </span>
      </span>

      <span
        className="a2-mono a2-hide-sm"
        style={{ fontSize: '.88rem', fontWeight: 700, color: 'var(--heading)', whiteSpace: 'nowrap' }}
      >
        {money(receipt?.net_amount)}
      </span>

      <span style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
        <IconButton
          icon="picture_as_pdf"
          title={`Descargar PDF de ${nombreDe(empleado)}`}
          aria-label={`Descargar PDF de ${nombreDe(empleado)}`}
          loading={bajando === 'pdf'}
          onClick={() => bajar('pdf')}
        />
        <IconButton
          icon="code"
          title={`Descargar XML de ${nombreDe(empleado)}`}
          aria-label={`Descargar XML de ${nombreDe(empleado)}`}
          loading={bajando === 'xml'}
          onClick={() => bajar('xml')}
        />
      </span>
    </div>
  );
};

export default ReceiptRow;
